module.exports = __webpack_public_path__ + "img/sport_utility_vehicle.9af2cc05.gif";